'use client'

import React, { PropsWithChildren, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { ProductCategory } from '@leid/api-products'

import apiClient from 'helpers/clients/apiClient'
import { displaySnackbar } from 'store/partials/snackbar/snackbarSlice'

import CategoriesContext from './CategoriesContext'

const ROTATION_TIME_IN_MILISECONDS = 60 * 60 * 1000 // One hour

const AppWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()

  const [categories, setCategories] = useState<ProductCategory[] | undefined>(undefined)

  useEffect(() => {
    fetchCategories()

    const categoriesTimer = setInterval(fetchCategories, ROTATION_TIME_IN_MILISECONDS)

    return () => {
      clearInterval(categoriesTimer)
    }
  }, [])

  const fetchCategories = async () => {
    const response = await apiClient.getProductCategories({
      active: true,
    })
    if (!response.success || !response.data) {
      dispatch(displaySnackbar({ message: t('error'), isError: true }))
      return
    }
    setCategories(response.data.rows)
  }

  return (
    <>
      <CategoriesContext.Provider value={{ isLoading: categories === undefined, categories: categories ?? [] }}>
        {children}
      </CategoriesContext.Provider>
    </>
  )
}

export default AppWrapper
